import styled from 'styled-components/macro';
import {Body1} from '../../../typography/typography';


export const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

export const MainContainer = styled.div`
    display: flex;
    flex-direction: ${({direction}) => direction};
    justify-content: space-around;
    align-items: center;

    @media (max-width: 1280px) {
        flex-direction: column;
    }
`;

export const ContentContainer = styled.div`
    width: ${({textContainer}) => (textContainer ? "40%" : "45%" )};
    margin: ${({textContainer,fyp}) => ((textContainer && !fyp) && "4rem 3rem 1rem 0rem" )};

    @media (max-width: 1280px) {
        width: ${({textContainer}) => (textContainer ? "70%" : "45%" )};
        margin:auto;
    },
    @media (max-width: 960px) {
        width: ${({textContainer}) => (textContainer ? "80%" : "80%" )};
        margin:auto;
    }

`;

export const Image = styled.img`
    object-fit: contain;
    max-width: 100%;
    height: auto;
`;

export const Text = styled(Body1)`

`;

export const Span = styled.span`
    display: block;
    margin: 2rem auto;
    
`;